<div class="checkbox-options">
    <div *ngFor="let option of options" class="checkbox-option">
        <label><input [(ngModel)]="option.isSelected" type="checkbox" (change)="checkboxChanged(option)"> {{option.text}}</label>
    </div>
</div>